/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import NotificationsList from "./NotificationsList"

import sendLogError from "../../sendLogError";
import ContextConstructor from "../../components/Context/Context";

/* MODULE IMPORTS */
import React, { Component } from "react";

/* CSS IMPORT */
import "./Notifications.css";
import { Loading } from "../../components/Loading/Loading";
import emailImg from "../../images/email.png";
import { ArrowLeft } from "lucide-react";
import { handleChannelBack } from "../../utils/handleChannelBack";

export class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      notificationsList: [],
      height: 0,
      width: 0,
      expanded: 0,
      open: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentDidMount() {
    if (
      this.context.selectedUserID !== "" &&
      this.context.selectedUserID !== undefined &&
      this.context.selectedUserID !== null
    ) {
      this.populateData();
      this.updateWindowDimensions();
    }
  }

  handleBack = () => {
    handleChannelBack({
      isMobileAuth: this.context.isMobileAuth,
      onWebBack: () => this.props.history.goBack(),
    });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }


  renderMailListTable(notificationsList) {
    return (
      <NotificationsList notifications={notificationsList} onClick={(id) => this.markNotificationAsRead(id, this.state)} />
    );
  }

  updateTableReadState(rowInfo, state) {

    state.data[rowInfo.index].isRead = true;

    this.setState({
      data: state.data,
      loading: false,
    });
  }

  renderListagemCorreio(notificationsList) {
    return (
      <main className="main-notification">
        <div className="title-bar title-bar-mail">
          <div className="title">
            <ArrowLeft
              className="profile-title-back"
              onClick={() => {
                this.handleBack();
              }}
            />
            Notificações
          </div>
        </div>
        <div className="notifications-list-wrapper">
          <div className="mail-list">{this.renderMailListTable(notificationsList)}</div>
        </div>
      </main>
    );
  }


  render() {
    let contents = "";

    if (this.state.loading) {
      contents = <Loading />;
    } else if (this.state.error) {
      contents = <ErrorPage />;
    } else {
      contents = this.renderListagemCorreio(this.state.notificationsList);
    }

    return <div>{contents}</div>;
  }

  async populateData() {
    try {
      const { selectedUserID, idToken } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        clientId: selectedUserID,
      };

      const response = await fetch(
        `/Notifications/GetNotifications?ClientId=${selectedUserID}`,
        { headers }
      );

      if (!response.ok) {
        this.setState({ loading: false, error: false });
        return;
      }

      const data = await response.json();

      const notifications = Array.isArray(data) ? data : [];

      // ordenação:
      const sorted = notifications.sort((a, b) => {
        if (a.isRead !== b.isRead) {
          return a.isRead ? 1 : -1; // não lidos primeiro
        }

        return new Date(b.date) - new Date(a.date); // mais recentes primeiro
      });

      this.setState({
        notificationsList: sorted,
        error: false,
        loading: false,
      });
    } catch (err) {
      console.error("Error fetching notifications:", err);

      this.setState({
        error: true,
        loading: false,
      });

      sendLogError(err.message, "populateData");
    }
  }

  async markNotificationAsRead(rowInfo, state) {
    try {
      const { idToken } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        "Content-Type": "application/json",
      };

      const id = rowInfo;

      // 1️⃣ marcar como lido
      const resMark = await fetch(
        `/Notifications/MarkNotificationAsRead?Id=${id}`,
        {
          method: "POST",
          headers,
        }
      );

      if (!resMark.ok) {
        throw new Error(`Erro MarkNotification: ${resMark.status}`);
      }

      const result = await resMark.json();

      // 2️⃣ dismiss notificação (não crítico)
      const resDismiss = await fetch(
        `/Notifications/DismissTopNotification?Id=${id}`,
        {
          method: "POST",
          headers,
        }
      );

      if (!resDismiss.ok) {
        console.warn("Dismiss failed:", resDismiss.status);
      }

      // 3️⃣ atualizar UI
      if (result === true) {
        this.updateTableReadState(rowInfo, state);
      }

    } catch (err) {
      console.error("Error marking notification as read:", err);

      sendLogError(err.message, "markNotificationAsRead");
    }
  }
}

Notifications.contextType = ContextConstructor;

export default Notifications;
